<div class="bar-graph-container" style="padding-top: 112px">
    <div class="title-container">
        <div class="subtitle subtitle-smaller">{{ title }}</div>
        <div class="title bold">
            {{ "graph.exhaust.title.bar" | translate }}
        </div>
    </div>
    <div #cylinder style="padding-top: 24px; padding-left: 24px">
        <div
            echarts
            [options]="echartsOptions"
            [extentions]="echartsExtentions"
            (chartInit)="onChartInit($event)"
        ></div>
    </div>
</div>
